module.exports = __webpack_public_path__ + "static/media/Douglas.4cb5ef35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Douglas.png
// module id = 619
// module chunks = 0